export default {"src":"/_next/static/media/hex.6313e3ee.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};